import React, { Component } from 'react';
import { API } from 'aws-amplify';
import "tabler-react/dist/Tabler.css";
import { Card, Dimmer } from "tabler-react";

import TablaReporteActividades from "./TablaReporteActividades";
import CardResultado from "./CardResultado";
import GraficaEntregas from "./GraficaEntregas";
import GraficaCalificaciones from "./GraficaCalificaciones";

class CardCurso extends Component {
  constructor(props) {
    super(props);
    this.state = { data: [], cursos: [], renderCard: '', actividades: [], foros: [], submissionsState: [], isLoading: true };
  }

  componentDidUpdate = (prevProps, prevState) => {
  }

  componentDidMount = async () => {
    await this.setState({
      data: this.props,
      renderCard: this.props.nombreCard,
    });
  }

  callBackTablaReporteActividades = (childData) => {
    this.setState({submissionsState: childData});
  }

  render() {
    return(
      <>
        <Card title={this.state.renderCard} className="card-div" isCollapsible isFullscreenable isCollapsed>
            <Card.Body>
              <Dimmer loader>
                <Card className="tabla-actividades">
                  <TablaReporteActividades data={this.props.curso} alumnos={this.props} returnFromChild={this.callBackTablaReporteActividades} />
                </Card>
                <div id={this.props.idTablaResultado}>
                  <CardResultado alumnos={this.props} data={this.state} courseTitle={this.state.renderCard} nivel={this.props.curso.nivel}/>
                </div>
                <div className="grid-graficas">
                  <Card className="grafica-col-1" title="Número de entregas por actividad" isCollapsible isFullscreenable >
                    <Card.Body>
                      <Dimmer loader>
                        <GraficaEntregas data={this.state.submissionsState} alumnos={this.props} curso={this.props.curso}/>
                      </Dimmer>
                    </Card.Body>
                  </Card>
                  <Card className="grafica-col-2" title="Calificaciones de alumnos por actividad" isCollapsible isFullscreenable>
                    <Card.Body>
                      <Dimmer loader>
                        <GraficaCalificaciones data={this.props.curso}/>
                      </Dimmer>
                    </Card.Body>
                  </Card>
                </div>
              </Dimmer>
            </Card.Body>
        </Card>
      </>
    );
  }
}
  
export default CardCurso;